// Render fragment for of — the entity's GraphQL display contract.
// Scaffolded once from the @medplum/definitions reverse projection; hand-curate
// freely to match what the view renders (this file is owned, not generated).
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a DiagnosticReport view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...DiagnosticReportRender }`, [DiagnosticReportRenderFragment]).
 * References are terminal ({ reference type display }) — expand nested
 * `resource` selections in the query when resolved targets are needed.
 */
export const DiagnosticReportRenderFragment = graphql(`
  fragment DiagnosticReportRender on DiagnosticReport @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    identifier {
      use
      system
      value
    }
    basedOn {
      reference
      type
      display
    }
    status
    category {
      text
      coding {
        system
        code
        display
      }
    }
    code {
      text
      coding {
        system
        code
        display
      }
    }
    subject {
      reference
      type
      display
    }
    encounter {
      reference
      type
      display
    }
    effectiveDateTime
    effectivePeriod {
      start
      end
    }
    issued
    performer {
      reference
      type
      display
    }
    resultsInterpreter {
      reference
      type
      display
    }
    specimen {
      reference
      type
      display
    }
    result {
      reference
      type
      display
    }
    imagingStudy {
      reference
      type
      display
    }
    media {
      comment
      link {
        reference
        type
        display
      }
    }
    conclusion
    conclusionCode {
      text
      coding {
        system
        code
        display
      }
    }
    presentedForm {
      contentType
      url
      title
      creation
    }
  }
`);
